__turbopack_context__.v({
  "card": "SpaceJoin-module-scss-module__DKGeWW__card",
  "image": "SpaceJoin-module-scss-module__DKGeWW__image",
  "link": "SpaceJoin-module-scss-module__DKGeWW__link",
  "subtitle": "SpaceJoin-module-scss-module__DKGeWW__subtitle",
  "text": "SpaceJoin-module-scss-module__DKGeWW__text",
  "title": "SpaceJoin-module-scss-module__DKGeWW__title",
});
